import { useEffect, useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import { useGetTaxcategoryQuery, useGetAllcompanyQuery } from '../../../../store/api/Salestaxes';
import Table from './Table';
const Tab1 = ({ pageState, setPageState }) => {
  const [taxoptions, setTaxoptions] = useState([])
  const [companyoptions, setCompanyoptions] = useState([])
  const { data: taxCat, isError, isLoading } = useGetTaxcategoryQuery()
  const { data: companydata } = useGetAllcompanyQuery()

  useEffect(() => {
    if (taxCat?.data?.length) {
      setTaxoptions(taxCat.data)
    }
  }, [taxCat])


  useEffect(() => {
    if (companydata?.data?.length) {
      setCompanyoptions(companydata.data)
    }
  }, [companydata])


  const [selectedCompany, setSelectedCompany] = useState('')

  return (
    <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>

        <div className="row mb-3" >

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              


                                    
              <div style={{ display: 'flex', gap: '15px' }}>
               <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Details</p>
                                    </div>

                                    </div>



              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="series"
                    label="Series"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="budget_against"
                    label="Budget Against"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="monthly_distribution"
                    label="Monthly Distribution"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
              </div>



              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="cost_center"
                    label="Cost Center"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="fiscal_year"
                    label="Fiscal Year"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="company"
                    label="Company"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>


  <div style={{ display: 'flex', gap: '15px' }}>
               <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Control Action</p>
                                    </div>

                                    </div>



              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  <label style={{ height: '5.4px' }}></label>
                  <Checkbox
                    id="aomr"
                    label="Applicable on Material Request"
                  />
                </div>

              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  {/* <label style={{ height: '10.4px' }}></label> */}
                  <Checkbox
                    id="aopo"
                    label="Applicable on Purchase Order"
                  />
                </div>

              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  {/* <label style={{ height: '10.4px' }}></label> */}
                  <Checkbox
                    id="aobae"
                    label="Applicable on booking actual expenses"
                  />
                </div>

              </div>




            </div>
          </div>

        </div>


        <div className="row mb-3" >

          <div className="col-md-12 px-2" >
            <div className='' style={{ height: "100%", display: 'flex', flexDirection: 'column', width: '100%', padding: '10px',border: '1px solid #DBDBDB', borderRadius: '5px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='p-1 m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Budget Accounts</p>
                </div>
              </div>

              <Table taxes={{ value: pageState.taxes, setValue: (v) => setPageState({ ...pageState, taxes: v }) }} compname={pageState.company} />



            </div>
          </div>

        </div>




      </div>
    </div>
  )
}

export default Tab1